<ol class="steplist">
  <li *ngFor="let item of items" [class.active]="item === step">
    {{('Case.CollectionProcess.' + item) | translate}}
  </li>
</ol>
